import React, { useEffect, useRef } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useNavigate
} from "react-router-dom";

import Dashboard from "./Components/Dashboard/Dashboard";
import Users from "./Components/Users/Users";
import UsersHistory from "./Components/Users/UsersHistory";
import Pairs from "./Components/Pairs/Pairs";
import "./App.css";
import OpenOrders from "./Components/Transaction/OpenOrders";
import PositionOrders from "./Components/Transaction/PositionOrders";
import UserWallet from "./Components/Users/UserWallet";
import Login from "./Components/Login/Login";
import consts from "./constant";
import TradeHistory from "./Components/TradeHistory/TradeHistory";
import PositionHistory from "./Components/PositionHistory/PositionHistory";
import Settings from "./Components/Settings/Settings";
import Home from "./Components/Home/Home";
import WinPercent from "./Components/WinPercent/WinPercent";
import Supports from "./Components/Supports/Supports";
import CreateOwnAssets from "./Components/CreateOwnAssets/CreateOwnAssets";
import HighLow from "./Components/CryptoTrade/highlow.jsx";
import UpDown from "./Components/CryptoTrade/updown.jsx";
import HighLowSpread from "./Components/CryptoTrade/highlowspread.jsx";
import SpinAndWin from "./Components/CryptoTrade/SpinAndWin.jsx";
import TapTrade from "./Components/CryptoTrade/taptrade.jsx";
import CreateOrUpdatePair from "./Components/Pairs/CreateOrUpdatePair";
import TradeSettings from "./Components/TradeSettings/TradeSettings";
import Deposit from "./Components/Deposit/Deposit.jsx";
import Withdraw from "./Components/Withdraw/Withdraw.jsx";
import Rolemanage from "./Components/SubAdmin/Rolemanage.jsx";
import Adminmanage from "./Components/SubAdmin/Adminmanage.jsx";
import SubadminActivities from "./Components/SubAdmin/SubadminActivities.jsx";
import HighlowSetting from "./Components/TradeSettings/HighLowSetting.jsx";
import UpdownSetting from "./Components/TradeSettings/UpdownSetting.jsx"
import HighlowSpreadSetting from "./Components/TradeSettings/HighlowSpreadSettings.jsx";
import TaptradeSetting from "./Components/TradeSettings/TapTradesettings.jsx";
import TradePatternSettings from "./Components/TradeSettings/TradePatternSettings.jsx";
import ManageTimeAmountSettings from "./Components/TradeSettings/ManageTimeAmountSettings.jsx";
import SpinAndWinSetting from "./Components/TradeSettings/SpinAndWinSettings.jsx";
import ProfitSegmentSettings from "./Components/TradeSettings/ProfitSegmentSettings.jsx";
import DepositManagement from "./Components/DepositManagement/DepositManagement.jsx";
import CryptoSettings from "./Components/DepositManagement/CryptoSettings.jsx";
import FiatSettings from "./Components/DepositManagement/FiatSettings.jsx";
import DepositHistory from "./Components/DepositManagement/DepositHistory.jsx";
import KycManagement from "./Components/KycManagement/KycManagement.jsx";
import UnderMaintenance from "./Components/UnderMaintenance/UnderMaintenance.jsx";
import Announcements from "./Components/Announcements/Announcements.jsx";
import Page404 from "./Components/404Page/page404.jsx";
import { PrivateRoute, ProtectedRoute, PublicRoute } from "./Reusable/AuthGuards/AuthGuards";
import { socket } from "./Config/socket.io.js";
import Pointssection from "./Components/TradeSettings/Pointssection.jsx";
import RtpEngineSettings from "./Components/TradeSettings/RtpEngineSettings.jsx";

function AppContent() {

  const base = consts.route;
  const navigate = useNavigate();
  const timerRef = useRef(null);

  // console.log(window.location.pathname, "pathnamepathname")

  useEffect(() => {
    socket.connect();
  }, []);

  //  Improved idle logout
  useEffect(() => {
    const logout = () => {
      if (localStorage.getItem("Jetix")) {
        if (timerRef.current) clearTimeout(timerRef.current);

        timerRef.current = setTimeout(() => {
          localStorage.clear();
          navigate(`/${base}`); // ✅ dynamic
        }, 1000 * 60 * 5); // 5 min
      }
    };

    // listen to multiple events
    const events = ["mousemove", "keydown", "click", "scroll"];

    events.forEach((event) => window.addEventListener(event, logout));

    logout(); // initial trigger

    return () => {
      events.forEach((event) => window.removeEventListener(event, logout));
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [navigate, base]);

  return (
    <div className="app-root">
      <Routes>
        {/* 🔹 Default redirect */}
        <Route path="/" element={<Navigate to={`/${base}`} />} />

        {/* Public */}
        <Route element={<PublicRoute />}>
          <Route path={`/${base}`} element={<Login />} />
        </Route>

        {/* Private */}
        <Route element={<PrivateRoute />}>
          <Route element={<Dashboard />}>
            <Route element={<ProtectedRoute permission="Dashboard" />}>
              <Route path={`/${base}/dashboard`} element={<Home />} />
            </Route>

            <Route element={<ProtectedRoute permission="Users" />}>
              <Route path={`/${base}/users`} element={<Users />} />
              <Route
                path={`/${base}/usersHistory`}
                element={<UsersHistory />}
              />
              <Route path={`/${base}/userwallet`} element={<UserWallet />} />
            </Route>

            {/* Individual CryptoTrade page permissions */}
            <Route element={<ProtectedRoute permission="HighLow" />}>
              <Route path={`/${base}/crypto/binary-history`} element={<HighLow />} />
            </Route>

            <Route element={<ProtectedRoute permission="UpDown" />}>
              <Route path={`/${base}/crypto/updown`} element={<UpDown />} />
            </Route>

            <Route element={<ProtectedRoute permission="HighLow Spread" />}>
              <Route path={`/${base}/crypto/highlowspread`} element={<HighLowSpread />} />
            </Route>

            <Route element={<ProtectedRoute permission="TapTrade" />}>
              <Route path={`/${base}/crypto/taptrade`} element={<TapTrade />} />
            </Route>

            <Route element={<ProtectedRoute permission="Spin And Win" />}>
              <Route path={`/${base}/crypto/spinandwin`} element={<SpinAndWin />} />
            </Route>

            <Route element={<ProtectedRoute permission="Crypto History" />}>
              <Route path={`/${base}/tradehistory`} element={<TradeHistory />} />
              <Route path={`/${base}/positionhistory`} element={<PositionHistory />} />
              <Route path={`/${base}/openorders`} element={<OpenOrders />} /> {/* ✅ fixed */}
              <Route path={`/${base}/positionorders`} element={<PositionOrders />} />
            </Route>

            <Route element={<ProtectedRoute permission="Trade Settings" />}>
              <Route
                path={`/${base}/tradesetting/binary-setting`}
                element={<HighlowSetting />}
              />
              <Route
                path={`/${base}/tradesetting/updownsetting`}
                element={<UpdownSetting />}
              />
              <Route
                path={`/${base}/tradesetting/highlowspreadsetting`}
                element={<HighlowSpreadSetting />}
              />
              <Route
                path={`/${base}/tradesetting/taptradesetting`}
                element={<TaptradeSetting />}
              />
              <Route
                path={`/${base}/tradesetting/patterns`}
                element={<TradePatternSettings />}
              />
              <Route
                path={`/${base}/tradesetting/manage-time-amount`}
                element={<ManageTimeAmountSettings />}
              />
              <Route
                path={`/${base}/tradesetting/profit-segments`}
                element={<ProfitSegmentSettings />}
              />
              <Route
                path={`/${base}/tradesetting/points`}
                element={<Pointssection />}
              />
              <Route
                path={`/${base}/tradesetting/rtp-engine`}
                element={<RtpEngineSettings />}
              />
            </Route>


            <Route element={<ProtectedRoute permission="Spin And Win Setting" />}>
              <Route
                path={`/${base}/tradesetting/spinandwinsetting`}
                element={<SpinAndWinSetting />}
              />
            </Route>

            {/* <Route element={<ProtectedRoute permission="Trade Settings" />}>
              <Route
                path={`/${base}/tradesetting`}
                element={<TradeSettings />}
              />
            </Route> */}

            <Route element={<ProtectedRoute permission="Pairs" />}>
              <Route path={`/${base}/pairs/edit/:id`} element={<CreateOrUpdatePair />} />
              <Route path={`/${base}/pairs/create`} element={<CreateOrUpdatePair />} />
              <Route path={`/${base}/pairs`} element={<Pairs />} />
            </Route>

            <Route element={<ProtectedRoute permission="Withdraw" />}>
              <Route path={`/${base}/withdraw`} element={<Withdraw />} />
            </Route>

            <Route element={<ProtectedRoute permission="KYC" />}>
              <Route path={`/${base}/kyc`} element={<KycManagement />} />
            </Route>

            <Route element={<ProtectedRoute permission="Payment Settings" />}>
              <Route path={`/${base}/payment-settings/crypto`} element={<CryptoSettings />} />
              <Route path={`/${base}/payment-settings/fiat`} element={<FiatSettings />} />
            </Route>

            <Route element={<ProtectedRoute permission="Deposit" />}>
              <Route path={`/${base}/deposit`} element={<Deposit />} />
              <Route path={`/${base}/deposit-history`} element={<DepositHistory />} />
            </Route>

            <Route element={<ProtectedRoute permission="Supports" />}>
              <Route path={`/${base}/supports`} element={<Supports />} />
            </Route>

            <Route element={<ProtectedRoute permission="Settings" />}>
              <Route path={`/${base}/settings`} element={<Settings />} />
              <Route path={`/${base}/winpercent`} element={<WinPercent />} />
              <Route
                path={`/${base}/createownassets`}
                element={<CreateOwnAssets />}
              />
            </Route>

            <Route element={<ProtectedRoute permission="Under Maintenance" />}>
              <Route path={`/${base}/under-maintenance`} element={<UnderMaintenance />} />
            </Route>

            <Route element={<ProtectedRoute permission="Announcements" />}>
              <Route path={`/${base}/announcements`} element={<Announcements />} />
            </Route>

            <Route element={<ProtectedRoute permission="Sub Admin" />}>
              <Route
                path={`/${base}/subadmin/rolemanage`}
                element={<Rolemanage />}
              />
              <Route
                path={`/${base}/subadmin/adminmanage`}
                element={<Adminmanage />}
              />
              <Route
                path={`/${base}/subadmin/activities`}
                element={<SubadminActivities />}
              />
            </Route>
          </Route>
        </Route>

        {/* 404 */}
        <Route path={`/${base}/page404`} element={<Page404 />} />
        <Route path="*" element={<Navigate to={`/${base}/page404`} />} />
      </Routes>
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
